<template>
    <div class="flex items-center justify-center w-full h-screen bg-img vx-row no-gutter" id="page-login">
        <div class="m-4 vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">

                    <div class="items-center justify-center vx-row no-gutter">

                        <div class="hidden vx-col lg:block lg:w-1/2">
                            <img src="@/assets/images/pages/app.png" width="445" alt="login" class="mx-auto">
                            <div class="flex flex-wrap items-center justify-end mr-base">
                              <span class="text-sm font-medium text-primary float-center">Versión {{ appVersion }}</span>
                            </div>
                        </div>

                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8 login-tabs-container mb-base">

                                <div class="mb-4 vx-card__title mt-base">
                                  <div class="flex flex-wrap items-center justify-center mt-2 mb-4">
                                    <h3 class="font-bold text-primary float-center">RIKUQ</h3>
                                  </div>
                                  <div class="flex flex-wrap items-center justify-center mt-2 mb-4">
                                    <h5 class="mb-4 font-medium float-center">{{ appName }}</h5>
                                  </div>
                                  
                                  <p>Bienvenido, inicie sesión con su cuenta.</p>
                                  
                                </div>

                                <div>
                                    <vs-input
                                        name="usuario"
                                        icon-no-border
                                        icon="icon icon-user"
                                        icon-pack="feather"
                                        label-placeholder="Usuario"
                                        v-model="usuario"
                                        class="w-full"/>

                                    <vs-input
                                        data-vv-validate-on="blur"
                                        v-validate="'required|min:4|max:20'"
                                        type="password"
                                        name="password"
                                        icon-no-border
                                        icon="icon icon-lock"
                                        icon-pack="feather"
                                        label-placeholder="Contraseña"
                                        v-model="password"
                                        v-on:keyup.enter="initSession"
                                        class="w-full mt-6" />
                                    <span class="text-sm text-danger">{{ errors.first('password') }}</span>

                                    <div class="flex flex-wrap justify-between my-5">
                                        <vs-checkbox v-model="checkbox_remember_me" class="mb-2">Recordarme</vs-checkbox>
                                    </div>
                                    

                                    <vs-button class="float-right mb-6" :disabled="!validateForm" @click="initSession">Ingresar</vs-button>
                                    
                                    <vs-divider icon-pack="feather" icon="icon-star" position="center" color="primary"></vs-divider>
                                    <router-link tag="div" class="flex items-center cursor-pointer vx-logo" to="/pages/politicas/privacidad">
                                        <span class="text-sm font-medium text-success">Políticas de Privacidad.</span>
                                    </router-link>
                                    <div class="flex flex-wrap items-center mt-4 social-login-buttons">
                                        <p>
                                            <span>&copy;</span>
                                            <span>{{ new Date().getFullYear() }}, </span>
                                            <a :href="appEntidadUrl" target="_blank" rel="nofollow">{{ appEntidad }}.</a>
                                        </p>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import { appName, appVersion, appEntidad, appEntidadUrl } from '@/constants/config';
export default{
    data() {
        return {
            appName: appName,
            appVersion: appVersion,
            appEntidad: appEntidad,
            appEntidadUrl: appEntidadUrl,

            usuario: "",
            password: "",
            checkbox_remember_me: false
        }
    },
    computed: {
        validateForm () {
            return !this.errors.any() && this.usuario !== '' && this.password !== ''
        }
    },
    methods: {
        initSession(){
            this.$vs.loading();
            const data = {
                username: this.usuario,
                password: this.password,
            };
            this.$store.dispatch("login", data)
            .then(response => {
                if(response.status === 200){
                    this.$vs.loading.close();
                    this.$router.push({ path: '/'});
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                if (error.response === undefined) {
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Ocurrio un error inseperado. Reporte el error al administrador.',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                } else if (error.response.status === 401) {
                    this.$vs.notify({
                        title: 'Error',
                        text: 'El usuario o contraseña es incorrecto.',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                } else {
                    this.$vs.notify({
                        title: 'Error',
                        text: 'Ocurrio un error inseperado. Intente mas tarde.',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
            });
        }
    }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
